//React
import React from 'react'
import { withRouter } from 'react-router';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//Action
import * as favoriteAction from '../action/favoriteAction';
import * as partnerOperationAction from '../action/partnerOperationAction';

//Dialog
import DialogFavoriteEdit from './DialogFavoriteEdit';
import DialogPaymentTicketSend from './DialogPaymentTicketSend';
//Icon
import MailIcon from '@material-ui/icons/Mail';
import StarRoundedIcon from '@material-ui/icons/StarRounded';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';

class Comp extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      favorite: props.favorite,
      favoriteDialogVisible: false,
      paymentTicketSendDialogVisible: false,
    }
  }

  _favoriteMyEdit(type) {
    this.setState({favoriteDialogVisible: false});

    if (type === 'add' || type === 'addNotice') {
      let notice;
      if (type === 'addNotice') {
        notice = 1;
      }
      else {
        notice = 0;
      }
      this.props.favoriteMyAdd(this.props.pic, notice, (data) => {
        this.setState({favorite: true})
      });
    }
    if (type === 'del') {
      this.props.favoriteMyDel(this.props.pic, () => {
        this.setState({favorite: false})
      });
    }
  }

  render() {
    return (

        <div style={{position:'fixed',bottom:'0',left:'0px',width:'100%' ,zIndex:'101'}}>
          <div className='footer_menu'>
            <div className='outer'>
                <div
                  className='link'
                  onClick={ () => this.props.history.push({pathname:"/mailbox/talk/" + this.props.pic, referrer: '/profile/'}) }
                >
                  <MailIcon className='icon' style={{color:'#FFAA57'}}/><div className='text'>メールを送る</div>
                </div>
                <div
                  className={['link', (this.state.favorite === true && 'selected')].join(' ')}
                  onClick={ () => {
                    if (this.props.my.proof.credit === 0 && this.props.my.proof.person === 0) {
                      this._favoriteMyEdit((this.state.favorite ? 'del': 'add'));
                    }
                    else {
                      this.setState({favoriteDialogVisible: true});
                    }
                  }}
                >
                  <StarRoundedIcon className='icon' style={{color:'#F95561'}}/><div className='text'>お気に入り</div>
                </div>

                <DialogFavoriteEdit
                  open={this.state.favoriteDialogVisible}
                  type={this.state.favorite ? 'del': 'add'}
                  apply={ (res) => this._favoriteMyEdit(res) }
                  close={ () => this.setState({favoriteDialogVisible: false}) }
                />
                {
                  (this.props.notification.paymentTicketSenderUnused > 0) && (
                    <div className='link' onClick={ () => this.setState({ paymentTicketSendDialogVisible: true}) }>
                      <CardGiftcardIcon className='icon' style={{color:'#CD4695'}}/><div className='text'>応援チケット</div>
                    </div>
                  )
                }
                <DialogPaymentTicketSend
                  open={this.state.paymentTicketSendDialogVisible}
                  pic={this.props.pic}
                  onClose={ () => this.setState({ paymentTicketSendDialogVisible: false}) }
                />
                <div
                  className='link'
                  onClick={ () => this.props.partnerOperationOpen(this.props.pic, ['memo', 'nondisplay', 'refusal', 'breach', 'footprintMyDel']) }
                >
                  <MoreVertSharpIcon className='icon' style={{color:'#4376AB'}}/><div className='text'>設定</div>
                </div>

            </div>
          </div>
        </div>

    )
  }
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
    notification: state.notification,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...favoriteAction,
    ...partnerOperationAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Comp));
